<template>
  <div
    class="h-100"
    style="position:relative"
  >
    <div class="campaign-details">
      <b-card
        title="Campaign Details"
      >
        <b-card-text>
          <dl class="m-0">
            <dt>Running Period</dt>
            <dd data-test="campaign-details-period">
              <template v-if="GET_CAMPAIGN_MIN_START_DATE&&GET_CAMPAIGN_MAX_END_DATE">
                {{ formatDateForPlatform(GET_CAMPAIGN_MIN_START_DATE) }} - {{ formatDateForPlatform(GET_CAMPAIGN_MAX_END_DATE) }}
              </template>
              <template v-else>
                &nbsp;
              </template>
            </dd>
            <dt>Total Budget</dt>
            <dd data-test="campaign-details-days">
              <template v-if="GET_CAMPAIGN_TOTAL_BUDGET">
                {{ GET_SELECTED_CURRENCY.symbolString }} {{ GET_CAMPAIGN_TOTAL_BUDGET }}
              </template>
              <template v-else>
                &nbsp;
              </template>
            </dd>
            <dt>Publishers</dt>
            <dd data-test="campaign-details-publishers">
              <template v-if="order.publisherIds? order.publisherIds.length !==0 : false">
                {{ order.publisherIds.length }}
              </template>
              <template v-else>
                &nbsp;
              </template>
            </dd>
            <dt>Countries</dt>
            <dd
              class="m-0"
              data-test="campaign-details-countries"
            >
              <template v-if="getTotalCountriesCount(order) !==0">
                {{ getTotalCountriesCount(order) }}
              </template>
              <template v-else>
                &nbsp;
              </template>
            </dd>
          </dl>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as types from '@/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

import dateHelper from '@/core/mixins/dateHelper';

export default {
  name: 'CampaignDetailsCard',
  mixins: [dateHelper],
  data() {
    return {
      order: {},
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
      'campaignChanges',
      'orderChanges',
      'regions',
    ]),
    ...mapGetters({
      currencyMap: types.GET_CURRENCY_MAP,
    }),
    ...mapGetters('campaigns', [
      campaignTypes.GET_SELECTED_CURRENCY,
      campaignTypes.GET_CAMPAIGN_TOTAL_BUDGET,
      campaignTypes.GET_CAMPAIGN_MIN_START_DATE,
      campaignTypes.GET_CAMPAIGN_MAX_END_DATE,
    ]),
  },
  methods: {
    setOrderDetails(payload) {
      this.order = payload;
    },
    getTotalCountriesCount(order) {
      const { geoTargeting } = order;
      if (!geoTargeting) return '';
      let count = 0;
      if (geoTargeting.regions && this.regions) {
        geoTargeting.regions.forEach((region) => {
          const refRegion = this.regions
            .find((item) => item.id === region);
          if (!refRegion) return '';
          if (geoTargeting.countryInclusionsExclusions.exclusions) {
            const { exclusions } = geoTargeting.countryInclusionsExclusions;
            count -= this.checkExclusionInRegion(exclusions, region);
          }
          count += refRegion.countries.length;
        });
      }
      if (geoTargeting.countryInclusionsExclusions) {
        if (geoTargeting.countryInclusionsExclusions.inclusions) {
          count += geoTargeting.countryInclusionsExclusions.inclusions.length;
        }
      }
      return count;
    },
    checkExclusionInRegion(exclusions, region) {
      const refRegion = this.regions.find((i) => i.id === region);
      let count = 0;
      exclusions.forEach((exclusion) => {
        refRegion.countries.forEach((country) => {
          if (exclusion === country) { count++; }
        });
      });
      return count;
    },
  },
};
</script>
<style lang="scss" scoped>
.campaign-details {
  position: sticky;
  right: 0;
  left: 0;
  top: 20px;
  z-index: 1;
  padding-bottom: 42px;
}
</style>
